export default {
  agendas: [],
};
